/**
 * HTMX Setup
 * Configures HTMX and makes it globally available
 */
import htmx from 'htmx.org';

// Make htmx globally available for templates and dynamic content
window.htmx = htmx;

// Swap content on error responses so server-rendered error templates are
// displayed. HTMX 2's default ignores 4xx/5xx bodies, which would hide the
// chat panel's error templates (chat_error_panel, message_send_error) and
// the global handle_unexpected_exception page's HX-Retarget swap.
htmx.config.responseHandling = [
    { code: "204", swap: false },
    { code: "[23]..", swap: true },
    { code: "[45]..", swap: true, error: true },
];

export { htmx };
